module.exports = __webpack_public_path__ + "static/media/heaterlux-1.9d76e0ee.jpg";